import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const getPageTitle = () => {
      const path = location.pathname;
      
      switch (path) {
        case '/':
        case '/dashboard':
          return 'SG - Inviolável | Dashboard';
        case '/comparativo':
          return 'SG - Inviolável | Comparativo';
        case '/franquias':
          return 'SG - Inviolável | Franquias';
        case '/usuarios':
          return 'SG - Inviolável | Usuários';
        case '/login':
          return 'SG - Inviolável | Login';
        default:
          return 'SG - Inviolável';
      }
    };

    document.title = getPageTitle();
  }, [location.pathname]);
};

export default usePageTitle;
